<div *ngIf="loading" class="overlay">
  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>
